import type { CustomIconProps } from '../CustomIcon';

export const VaultCopyIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 28 24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        fill={solid ? color : 'none'}
        stroke={solid ? color : secondaryColor}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.6854 2H11.3135C8.04757 2 6 4.31243 6 7.58486V16.4151C6 19.6876 8.03676 22 11.3135 22H20.6843C23.9611 22 26 19.6876 26 16.4151V7.58486C26 4.31243 23.9611 2 20.6854 2Z'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <circle
        cx='14'
        cy='12'
        r='3'
        stroke={secondaryColor}
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <circle cx='21' cy='8' r='1' fill={secondaryColor} />
      <circle cx='21' cy='16' r='1' fill={secondaryColor} />
      <circle cx='21' cy='12' r='1' fill={secondaryColor} />
      <circle cx='7' cy='15' r='6' fill={secondaryColor} stroke='white' strokeWidth='2' />
      <path d='M7 18V15M7 12V15M7 15H10M7 15H4' stroke='white' strokeWidth='1.5' />
    </svg>
  );
};
